<div>
    <form [formGroup]="epicasGroup" autocomplete="off">
    <div class="row">
        <div class="col-sm-12">
            <h6>T&iacute;tulo:</h6>
            <mat-form-field>
                <mat-label>Para:</mat-label>
                <textarea aria-label="Para:" formControlName='tituloCtrl' maxlength="200" matInput placeholder="Título:" [(ngModel)]="objetoEpicas.nombre"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>Descripción:</mat-label>
                <textarea aria-label="Descripción:" formControlName='descripcionCtrl' maxlength="500" matInput placeholder="Descripción"
                    [(ngModel)]="objetoEpicas.descripcion"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <mat-form-field appearance="outline">
                <mat-label>Prioridad:</mat-label>
                <mat-select formControlName='prioridadCtrl' selected="selected"
                    placeholder="Prioridad" [(ngModel)]="objetoEpicas.prioridad">
                    <mat-option *ngFor="let item of prioridad" [value]="item.id_probabilidad">
                        {{item.valor}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field appearance="outline">
                <mat-label>Riesgo:</mat-label>
                <mat-select formControlName='riesgoCtrl' selected="selected"
                    placeholder="Riesgo" [(ngModel)]="objetoEpicas.riesgo">
                    <mat-option *ngFor="let item of riesgo" [value]="item.id_impacto">
                        {{item.valor}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field appearance="fill">
                <mat-label>Esfuerzo:</mat-label>
                <input aria-label="Esfuerzo:" formControlName='esfuerzoCtrl' matInput maxlength="2" soloNumero placeholder="Esfuerzo" [(ngModel)]="objetoEpicas.esfuerzo">
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field appearance="fill">
                <mat-label>Valor de negocio:</mat-label>
                <input aria-label="Valor de negocio:" formControlName='valorNegocio' matInput maxlength="2" soloNumero placeholder="Ingrese valor"
                    [(ngModel)]="objetoEpicas.valor_negocio">
            </mat-form-field>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-4">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label> Fecha de inicio </mat-label>
                <input aria-label="Fecha de inicio" formControlName='fechaInicio' matInput [matDatepicker]="picker" readonly (dateChange)="validarFechaInicio($event)"
                [(ngModel)]="objetoEpicas.fecha_inicio">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Fecha planeada fin:</mat-label>
                <input aria-label="Fecha planeada fin:" formControlName='fechaPlaneadaFin' matInput [matDatepicker]="picker2" readonly [min]="minDateFin"
                [(ngModel)]="objetoEpicas.fecha_planeada_termino" (dateChange)="validaFechaFin($event)">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Tiempo cr&iacute;tico:</mat-label>
                <input aria-label="Tiempo crítico:" formControlName='tiempoCritico' maxlength="3" matInput placeholder="Tiempo:" soloNumero [(ngModel)]="objetoEpicas.tiempo_critico">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <button mat-button class="btn  btn-success" [disabled]="epicasGroup.invalid" (click)="guardarEpica()">
                Guardar <i class='material-icons'> save </i>
            </button>
        </div>
    </div>
    </form>
</div>